module.exports = __webpack_public_path__ + "static/media/Spiderweb03.30662d93.png";


//////////////////
// WEBPACK FOOTER
// ./src/images/GameTheme/Background/Spiderweb03.png
// module id = 690
// module chunks = 0